import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TTags } from './models';

export const Tags: FC<TTags> = ({
    Tag,
    Text,
    caption,
    className,
    config,
    name,
    onClick,
    selected,
    styles,
    tags,
}) => {
    return (
        <div className={className}>
            <Text
                className={cn(styles?.text, styles?.external)}
                dataTestId={`${name}-caption`}
                styler={{ margin: 0, padding: 0 }}
                view={config.caption}
            >
                {caption}
            </Text>
            {tags &&
                tags.map(tag => (
                    <Tag
                        key={tag.value}
                        label={tag.label as string}
                        onClick={onClick}
                        selected={selected}
                        size={config.tagSize}
                        styler={config.tagStyler}
                        value={tag.value}
                    />
                ))}
        </div>
    );
};
